import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { lookup } from 'mime-types';
import Iconify from '../../components/iconify/component';
import Image from '../Image';
import { checkUndefinedNullOrEmpty, getBestRate } from '../Tools';
import type { UploadArrayItem } from './Image';

export function getFileIcon(fileName: string, size: string | number, loading: boolean, elementId: string) {
    if (loading) return <CircularProgress key={'inputfield' + elementId + '_getFileIconLoading'} color="primary" size={size} sx={{ flexShrink: 0 }} />;
    else {
        return (
            <Iconify
                key={`inputfield${elementId}_${
                    fileName?.toLowerCase()?.endsWith('jpg') ||
                    fileName?.toLowerCase()?.endsWith('jpeg') ||
                    fileName?.toLowerCase()?.endsWith('png') ||
                    fileName?.toLowerCase()?.endsWith('tif') ||
                    fileName?.toLowerCase()?.endsWith('tiff')
                        ? 'getFileIconImage'
                        : fileName?.toLowerCase()?.endsWith('pdf')
                          ? 'getFileIconPdf'
                          : fileName?.toLowerCase()?.endsWith('zip')
                            ? 'getFileIconZip'
                            : 'getFileIconQuestion'
                }`}
                icon={
                    fileName?.toLowerCase()?.endsWith('jpg') ||
                    fileName?.toLowerCase()?.endsWith('jpeg') ||
                    fileName?.toLowerCase()?.endsWith('png') ||
                    fileName?.toLowerCase()?.endsWith('tif') ||
                    fileName?.toLowerCase()?.endsWith('tiff')
                        ? 'mdi:file-image'
                        : fileName?.toLowerCase()?.endsWith('pdf')
                          ? 'mdi:file-pdf-box'
                          : fileName?.toLowerCase()?.endsWith('zip')
                            ? 'mdi:zip-box'
                            : 'mdi:file-question'
                }
                sx={{ flexShrink: 0 }}
                width={size}
            />
        );
    }
}

export function getFileComponent(file: UploadArrayItem, elementId: string) {
    const icon = getFileIcon(file?.file?.name, 20, false, elementId);
    const mimeType = lookup(file?.file?.name) || '';
    const isImage = mimeType?.startsWith('image/');
    return (
        <Grid direction="column" item xs={6} sm={4} md={3}>
            <Stack alignItems="center" justifyContent="center" gap={1} sx={{ aspectRatio: 1, backgroundColor: 'background.paper', position: 'relative', width: 1 }}>
                {isImage && !checkUndefinedNullOrEmpty(file?.url) ? <Image externalImage ratio={[1, 1]} src={file?.url} /> : icon}
                <Stack alignItems="center" justifyContent="center" sx={{ mb: isImage ? 1 : undefined }}>
                    <Typography variant="body2" sx={{ fontSize: '0.85em' }}>
                        {file?.file?.name}
                    </Typography>
                    <Typography variant="subtitle2">{getBestRate(file?.file?.size, 1024, ['B', 'KB', 'MB', 'GB', 'TB', 'PB'])}</Typography>
                </Stack>
                <LinearProgress
                    color={file?.progress === false ? 'error' : 'primary'}
                    value={file?.progress === true ? 0 : file?.progress === false ? 100 : file?.progress}
                    valueBuffer={0}
                    sx={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}
                    variant={file?.progress === true ? 'indeterminate' : 'buffer'}
                />
            </Stack>
        </Grid>
    );
}
